import { useQueryClient } from "@tanstack/react-query";

import { subscriptionQueryOptions } from "@/domains/subscriptions/factories/subscription-query-options";
import { useSubscriptionLink } from "@/domains/subscriptions/queries/use-subscription-link";
import { Button, icons, Modal } from "@/ui";

type ManageSubscriptionModalProps = {
  isOpen: boolean;
  closeModal: () => void;
};

export const ManageSubscriptionModal = ({ closeModal, isOpen }: ManageSubscriptionModalProps) => {
  const queryClient = useQueryClient();
  const { isError, isFetching, refetch } = useSubscriptionLink(false);

  const handleClose = () => {
    queryClient.removeQueries({ queryKey: subscriptionQueryOptions.link.queryKey });
    closeModal();
  };

  const handleGo = async () => {
    const result = await refetch();
    if (result.data?.link) {
      const newWindow = window.open(result.data.link, "_blank", "noopener,noreferrer");
      if (newWindow) {
        // Defense in depth: remove opener to prevent reverse tab nabbing/phishing redirects in older browsers that do not support "noopener".
        newWindow.opener = null;
      }
      handleClose();
    }
  };

  return (
    <Modal
      className="text-center"
      closeEnabled={!isFetching}
      closeModal={handleClose}
      isOpen={isOpen}
      title={isError ? "Unable to Load Portal" : "You're Being Routed to Your Subscription Manager"}
    >
      <div className="flex flex-col items-center gap-6 px-6 pb-10">
        <Button className="w-full justify-center" isLoading={isFetching} onClick={handleGo}>
          {isError ? (
            "Try Again"
          ) : (
            <span className="flex items-center gap-1">
              Go
              <icons.ArrowRight className="size-5" />
            </span>
          )}
        </Button>
      </div>
    </Modal>
  );
};
